import { DropdownOption } from '@hawkins/components';

export const wrapIntoDropdownOption = <ValueType>(
  label: string,
  value: ValueType
): DropdownOption<ValueType> => ({
  label,
  value,
});
